import {Pipe, PipeTransform} from "@angular/core";
import {Temporal} from "temporal-polyfill";
import {PlainDateFormat, TemporalFormatering} from "felles-ng2/tjenester/TemporalFormatering";
import {PlainDateSerialisert} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {lesPlainDateSerialisertOpt} from "felles-ng2/støttefunksjoner/temporal";
import PlainDate = Temporal.PlainDate;

/**
 * Formaterer PlainDate instanser.
 *
 * Angitt dato kan være av typen PlainDate, PlainDateSerialisert
 * Format kan angis som argument nr 2,
 * 'short' gir '11.07.2014', 'medium' gir '11. juli 2014' og 'long' gir 'fredag 11. juli 2014'.
 *
 * Eksempler:
 * `{{ enDato|plaindate:'medium' }}`
 * `{{ enDato|plaindate:{year: 'numeric', month: 'short'} }}`
 *
 * Se tester TemporalFormatering.jestspec.ts for eksempler på ulike formater.
 */
@Pipe({name: 'plaindate', pure: true, standalone: true})
export class FormaterPlainDatePipe implements PipeTransform {

    constructor(private formatering: TemporalFormatering) {
    }

    transform(dato: PlainDate | PlainDateSerialisert | null, format: PlainDateFormat = 'short'): string {
        return this.formatering.formaterPlainDate(
          (dato instanceof PlainDate) ? dato : lesPlainDateSerialisertOpt(dato),
          format);
    }
}
